import React from 'react';
import { clsx, createUseStyles } from '@pushpay/styles';
import Skeleton from './skeleton';
const useStyles = createUseStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center'
  },
  itemWrapper: {
    '& + &': {
      margin: `0 0 0 ${theme.SPACING.XXSMALL}`
    }
  },
  item: {
    height: '10px',
    borderRadius: 0
  }
}));
export const SkeletonHeatMapLegend = ({
  itemCount,
  classes: classesProp,
  className: classNameProp,
  ...rest
}) => {
  const classes = useStyles(classesProp);
  const className = clsx(classNameProp, classes.root);
  const width = 100 / itemCount;
  const rows = new Array(itemCount).fill(null).map(_ => ({
    width
  }));
  return /*#__PURE__*/React.createElement(Skeleton, Object.assign({
    rows: rows,
    className: className,
    classes: {
      row: classes.itemWrapper,
      content: classes.item
    }
  }, rest));
};